import React from 'react';

const OfferExpandedTwo = () => {
	return (
		<div className='offer__section5'>
			<div className='offer__title'>Program obozu</div>
			<div className='offer__expanded '>
				<div className='expanded__title title__border'>1. Nauki przyrodnicze</div>
				<p className='expanded__text'>
					Zajęcia z nauk przyrodniczych przygotowane z myślą o najmłodszych, które łączą elementy biologii, fizyki i chemii w formie doświadczeń, obserwacji oraz prostych eksperymentów opartych na ciekawości świata. Program nie wymaga zaawansowanego aparatu matematycznego ani wiedzy podręcznikowej – punktem wyjścia są pytania, zjawiska i codzienne doświadczenia uczestników. Uczniowie uczą się poprzez działanie, odkrywanie zależności i samodzielne formułowanie wniosków. Głównym celem zajęć jest rozbudzenie naturalnego zainteresowania naukami przyrodniczymi i stworzenie pozytywnych skojarzeń z dalszą nauką biologii, fizyki i chemii.
				</p>
				<div className='expanded__cross'>
					<span className='cross__cross1'></span>
					<span className='cross__cross2'></span>
				</div>
			</div>
			<div className='offer__expanded '>
				<div className='expanded__title title__border'>
					2. Fizyka 
				</div>
				<p className='expanded__text'>
					 Podobno fizyka jest trudna i nikt nigdy jej nie rozumiał. Właśnie dlatego nasze zajęcia z fizyki to początkowo opowiadanie bajek. Staramy się wprowadzić w zagadnienie językiem zrozumiałym dla młodych ludzi, pobudzić ich wyobraźnię i zmusić do myślenia. Najważniejsze jest zrozumienie omawianego zagadnienia na poziomie możliwie najbliższym intuicji. I twierdzimy, że da się to zrobić językiem zrozumiałym. Ale ponieważ nie samymi bajkami człowiek żyje, więc później próbujemy to wszystko ująć w odpowiedni dla wieku młodych ludzi aparat matematyczny. I tam dopiero zaczyna się taka zabawa, jaką wszyscy najbardziej lubią.
				</p>
				<div className='expanded__cross'>
					<span className='cross__cross1'></span>
					<span className='cross__cross2'></span>
				</div>
			</div>
			<div className='offer__expanded '>
				<div className='expanded__title title__border'>
					3. Fizyka – program maturalny
				</div>
				<p className='expanded__text'>
					Jesteś uczniem klasy III LO lub IV technikum, zastanawiasz się nad
					studiami technicznymi i maturą z fizyki. Proponujemy w ramach obozu
					Osada Wiedzy kurs maturalny w ramach, którego dowiecie się w jaki
					sposób rozwiązywać zadania maturalne, na co zwrócić uwagę podczas
					rozwiązywania arkusza maturalnego. Jakie są „pewniaki” na egzaminie z
					fizyki, które zadania sprawiają najwięcej trudności. Przekopiemy się
					przez teorię i zadania ze wszystkich działów fizyki szkoły średniej.
					Kurs umożliwi Ci podjęcie decyzji maturalnej i ułatwi przygotowania do
					czekającej matury z fizyki W ramach kursu każdy otrzyma zbiór zadań
					maturalnych i vademecum maturzysty.
					<br />
					<br />
					<i>
						To będzie intensywny czas, który pozwoli Ci nadrobić zaległości z
						poprzednich lat i pozwoli ze spokojną głową podejść do matury.
					</i>
				</p>
				<div className='expanded__cross'>
					<span className='cross__cross1'></span>
					<span className='cross__cross2'></span>
				</div>
			</div>
			<div className='offer__expanded '>
				<div className='expanded__title title__border'>4. Chemia – program maturalny</div>
				<p className='expanded__text'>
					Jesteś uczniem szkoły ponadpodstawowej i chcesz solidnie przygotować
					się do egzaminu maturalnego z chemii? Nasze zajęcia to połączenie
					intensywnej nauki oraz wsparcia doświadczonych nauczycieli, które
					pozwolą Ci osiągnąć najlepsze wyniki na maturze! Wspólnie powtórzymy
					kluczowe zagadnienia, które pojawiają się na egzaminie maturalnym,
					abyś mógł czuć się pewnie i przygotowany. Przeprowadzimy intensywne
					warsztaty, podczas których będziesz rozwiązywać zadania z komentarzem
					egzaminatorów maturalnych. Pokażemy Ci, jak efektywnie pracować z
					zadaniami, na co zwracać uwagę i jak unikać najczęściej popełnianych
					błędów. Nasz zespół to wykwalifikowani i doświadczeni nauczyciele
					chemii, którzy doskonale znają wymagania maturalne. Służymy pomocą i
					wsparciem na każdym etapie przygotowań, odpowiadając na Twoje pytania
					i wyjaśniając trudniejsze zagadnienia.
					<ul className='expanded__list'>
						<p>Co możesz zyskać dzięki naszym zajęciom?</p>
						<li>
							Pewność siebie: Dzięki solidnemu przygotowaniu teoretycznemu i
							praktycznemu.
						</li>
						<li>Wiedza: Dogłębne zrozumienie materiału maturalnego.</li>
						<li>
							Strategie egzaminacyjne: Techniki rozwiązywania zadań maturalnych{' '}
						</li>
						<li>Motywacja: Inspiracja do dalszego zgłębiania chemii.</li>
					</ul>
				</p>
				<div className='expanded__cross'>
					<span className='cross__cross1'></span>
					<span className='cross__cross2'></span>
				</div>
			</div>
			<div className='offer__expanded '>
				<div className='expanded__title title__border'>5. Biologia – program maturalny</div>
				<p className='expanded__text'>
					Jesteś uczniem szkoły ponadpodstawowej i chcesz zdać maturę z
					biologii? Nasze zajęcia z biologii to nie tylko podręczniki i wykłady
					- to interaktywna podróż przez tajemnice życia na organizmów. Dowiedz
					się, jak funkcjonuje każdy organizm, od mikroskopijnych komórek po
					majestatyczne ekosystemy . Nasza kadra to pełni pasji nauczyciele
					biologii, którzy nie tylko doskonale znają materiał maturalny, ale
					także potrafią przekazać go w sposób interesujący i przystępny. Dzięki
					nim każde zajęcia staną się inspirującą podróżą do świata biologii.
					Nasze zajęcia pomogą Ci zrozumieć i zapamiętać materiał w sposób
					trwały i przyjemny. Otrzymasz wsparcie, które pomoże Ci nadrobić
					zaległości i rozwiać wszelkie wątpliwości, a nasz program jest
					dokładnie dostosowany do wymagań egzaminu maturalnego. Zapewniamy
					pasjonujące spotkania, ciekawe wykłady i praktyczne ćwiczenia, które
					pobudzą Twoją ciekawość i rozwijają zrozumienie biologicznych
					procesów. Dołącz do naszej społeczności biologicznych entuzjastów i
					odkryj, jak wspaniałe może być studiowanie życia!"
				</p>
				<div className='expanded__cross'>
					<span className='cross__cross1'></span>
					<span className='cross__cross2'></span>
				</div>
			</div>
			<div className='offer__expanded '>
				<div className='expanded__title title__border'>6. Matematyka</div>
				<p className='expanded__text'>
					Matematyka - program dla dzieci
					<br />
					Zajęcia skierowane są dla uczniów klas 4-6. Jest to ważny czas w rozwoju ucznia, w szkole dzieci uczą się podstawowych pojęć i narzędzi matematycznych, na bazie których w kolejnych latach swojej edukacji będą poszerzać swoje umiejętności. Na Osadzie pomagamy w opanowaniu tych kompetencji, rozwoju myślenia analitycznego i problemowego. Chcemy aby najmłodsi z naszych podopiecznych zaciekawili się zgłębianiem zagadnień matematycznych. Uczymy od podstaw,  bo właśnie tam rodzi się zrozumienie.
					<br /><br />
					Matematyka - program dla młodzieży
					<br />
					Zajęcia przeznaczone są dla uczniów po 7 klasie. Na obozie uczymy młodzież jak rozwiązywać trudniejsze problemy matematyczne. Utrwalamy wiedzę, którą zdobyli dotychczas podczas wcześniejszych etapów edukacji, ale co najważniejsze rozszerzamy ją tak, aby nie ograniczać się w szkolnych ramach. Uczymy kreatywnego podejścia i zachęcamy do szukania nowych, ciekawych rozwiązań. Pokazujemy jak te umiejętności wykorzystywane są w innych naukach m. in. w fizyce czy programowaniu. 
					<br /><br />
					Matematyka - program maturalny
					<br />
					Kurs ten skierowany jest dla przyszłych maturzystów, którzy chcą zrozumieć i opanować materiał z matematyki na poziomie szkoły średniej i uzyskać jak najlepsze wyniki z egzaminu dojrzałości. Stawiamy na analizowanie i rozwiązywanie zadań problemowo, a nie trzymanie się utartych schematów. Uczymy uczestników obozów jak ich nietuzinkowe pomysły zapisać poprawnym językiem matematycznym. Na zajęciach wprowadzane są również elementy matematyki wyższej. Pozwala to na omówieniu danych zagadnień w sposób kompletny i przydaje to się przyszłym studentom kierunków ścisłych oraz technicznych.

				</p>
				<div className='expanded__cross'>
					<span className='cross__cross1'></span>
					<span className='cross__cross2'></span>
				</div>
			</div>
			<div className='offer__expanded '>
				<div className='expanded__title title__border'>7. Programowanie</div>
				<p className='expanded__text'>
					Zajęcia z programowania są prowadzona w zależności od zaawansowania
					uczestników. Może to być nauka podstaw programowania i algorytmów (w
					jednym z trzech języków: C++, Python, JavaScript). Dla zaawansowanych
					może to być rozwiązywanie zadań z pogranicza olimpiady informatycznej,
					bazujących na strukturach danych czy grafach lub stworzenie projektu
					praktycznego. Każdy rodzaj zajęć ma na celu rozwinięcie pasji
					związanych z programowaniem oraz pomoc w zrozumieniu komputerów i
					informatyki, a także powiązanie programowania z matematyką i fizyką.
				</p>
				<div className='expanded__cross'>
					<span className='cross__cross1'></span>
					<span className='cross__cross2'></span>
				</div>
			</div>
			<div className='offer__expanded '>
				<div className='expanded__title title__border'>
					8. Program kompetencji społecznych – wspólny fundament obozu
				</div>
				<p className='expanded__text'>
					Podczas obozu naukowego realizujemy autorski program rozwoju kompetencji społecznych i emocjonalnych, który jest integralną częścią całościowego doświadczenia edukacyjnego. Zajęcia te wspierają uczestników nie tylko w nauce, ale przede wszystkim w rozwoju osobowości, budowaniu odporności psychicznej i umiejętności potrzebnych w codziennym życiu szkolnym i społecznym.
					Program realizowany jest w sposób <bold>zróżnicowany i dostosowany do wieku oraz etapu rozwojowego uczestników</bold>, z wykorzystaniem pracy warsztatowej, ćwiczeń praktycznych, elementów psychoedukacji, pracy w grupach oraz refleksji indywidualnej.
					<br /><br />
					<bold>Program dla dzieci (uczniowie klas IV–VI szkoły podstawowej)</bold>
					<br />
					Zajęcia kompetencji społecznych dla dzieci mają na celu wspieranie ich w odkrywaniu siebie, budowaniu poczucia własnej wartości oraz bezpiecznym rozwijaniu relacji z rówieśnikami.
					<br />
					<ol>
						Podczas zajęć dzieci:
						<li>uczą się rozpoznawać swoje mocne strony i budować pozytywny obraz siebie,</li>
						<li>rozwijają pewność siebie i wiarę we własne możliwości,</li>
						<li>poznają sposoby wyrażania emocji i potrzeb w sposób adekwatny i bezpieczny,</li>
						<li>uczą się stawiania prostych celów oraz budowania drogi do ich realizacji,</li>
						<li>uczą się selekcjonować opinie innych tak, aby nie obniżały ich poczucia wartości,</li>
						<li>wzmacniają motywację wewnętrzną i poczucie sprawczości.</li>
					</ol>
					<br />
					<bold>Program dla młodzieży (uczniowie klas VII–VIII szkoły podstawowej oraz szkół ponadpodstawowych)</bold>
					<br />
					Program kompetencji społecznych dla młodzieży odpowiada na wyzwania okresu dorastania, takie jak presja rówieśnicza, budowanie tożsamości, motywacja do nauki oraz radzenie sobie z emocjami i stresem.
					<br />
					<ol>
						W trakcie zajęć młodzież:
						<li>nad budowaniem stabilnego poczucia własnej wartości i pewności siebie,</li>
						<li>uczy się świadomie wyznaczać cele życiowe i edukacyjne oraz planować drogę do ich realizacji,</li>
						<li>rozwija umiejętność obiektywnego selekcjonowania opinii i informacji z otoczenia,</li>
						<li>wzmacnia motywację wewnętrzną i odpowiedzialność za własne decyzje,</li>
						<li>uczy się budować zdrowe relacje z innymi, oparte na szacunku i komunikacji,</li>
						<li>ćwiczy postawy asertywne i umiejętność obrony własnej przestrzeni psychicznej,</li>
						<li>poznaje techniki pracy z myślami i emocjami w sytuacjach trudnych.</li>
					</ol>
					
					Zajęcia mają charakter warsztatowy i refleksyjny, są prowadzone w sposób partnerski i dostosowany do poziomu dojrzałości uczestników. Młodzież ma przestrzeń do rozmowy, zadawania pytań i konfrontowania swoich doświadczeń w bezpiecznym środowisku.
					<br /><br />
					<bold>Program maturalny (uczniowie szkół ponadpodstawowych przygotowujący się do matury)</bold>
					<br />
					Program kompetencji społecznych dla maturzystów został zaprojektowany jako realne wsparcie w jednym z najbardziej wymagających momentów edukacyjnych. Zajęcia łączą rozwój osobisty z psychoedukacją, pomagając uczestnikom skuteczniej radzić sobie z presją egzaminacyjną.
					<br />
					<ol>
						W ramach programu uczestnicy:
						<li>wzmacniają poczucie własnej wartości i pewność siebie w kontekście wyzwań maturalnych,</li>
						<li>uczą się zarządzania stresem i napięciem związanym z egzaminami,</li>
						<li>poznają elementy psychologii pozytywnej i mindfulnessu,</li>
						<li>uczą się regulować procesy emocjonalne i obniżać poziom przeciążenia psychicznego,</li>
						<li>dowiadują się, jak działa umysł w sytuacjach stresowych i jak ograniczyć nadmierne analizowanie,</li>
						<li>rozwijają umiejętność koncentracji, uważności i pracy z własnymi zasobami,</li>
						<li>uczą się budować realistyczne cele i utrzymywać motywację w długotrwałym procesie nauki.</li>
					</ol>
					Zajęcia mają charakter praktyczny i wspierający – są przestrzenią, w której maturzyści mogą zatrzymać się, uporządkować myśli i nauczyć się działać skuteczniej, bez nadmiernego napięcia i presji.
				</p>
				<div className='expanded__cross'>
					<span className='cross__cross1'></span>
					<span className='cross__cross2'></span>
				</div>
			</div>
			<div className='offer__expanded '>
				<div className='expanded__title'>9. Czas wolny</div>
				<p className='expanded__text'>
					Czas wolny uczestników obozu to korzystanie z plaży, boiska do
					siatkówki, kąpiel w jeziorze. Czas wolny przeznaczony jest także na
					indywidualne konsultacje z nauczycielami prowadzącymi zajęcia,
					mentoring a także dyskusje naukowe uczestników obozu. W trakcie obozu
					rozegrany zostanie także <b>Turniej Osady</b>. Uczestnicy zostaną
					podzieleni na grupy. W trakcie obozu będą rozwiązywać różnorodne
					zadania z matematyki, fizyki i programowania. W dniach, w których nie
					będą odbywać się wykłady, uczestnicy będą przystępowali do zadań
					grupowych np. logiczne i strategiczne gry planszowe.
				</p>
				<div className='expanded__cross'>
					<span className='cross__cross1'></span>
					<span className='cross__cross2'></span>
				</div>
			</div>
		</div>
	);
};

export default OfferExpandedTwo;
